import { TrustedWidgetConfig } from "../types";

export const getImageURL = (
  path?: string,
  backendURL?: string
): string | undefined => {
  if (!path || typeof path !== "string") return undefined;
  return path.startsWith("http://") || path.startsWith("https://")
    ? path
    : `${backendURL}/${path}`;
};

export const generateStyles = ({ customStyles }: TrustedWidgetConfig) => {
  return {
    text: customStyles?.global?.color?.text || "#666666",
    background: customStyles?.global?.color?.background || "#ffffff",
    borderRadius: customStyles?.global?.borderRadius || "8px",
    accountButton: {
      text: customStyles?.components?.accountButton?.text || "#666666",
      background:
        customStyles?.components?.accountButton?.background || "#efefef",
      hover: customStyles?.components?.accountButton?.hover || undefined,
      position: customStyles?.components?.accountButton?.position || "left",
    },
    primaryButton: {
      text: customStyles?.components?.primaryButton?.text || "#ffffff",
      background:
        customStyles?.components?.primaryButton?.background || "#b5262f",
      hover: customStyles?.components?.primaryButton?.hover || undefined,
      position: customStyles?.components?.primaryButton?.position || "center",
    },
    secondaryButton: {
      text:
        customStyles?.components?.secondaryButton?.text ||
        customStyles?.components?.primaryButton?.text ||
        "#ffffff",
      background:
        customStyles?.components?.secondaryButton?.background ||
        customStyles?.components?.primaryButton?.background ||
        "#b5262f",
      hover:
        customStyles?.components?.secondaryButton?.hover ||
        customStyles?.components?.primaryButton?.hover ||
        undefined,
      position:
        customStyles?.components?.secondaryButton?.position ||
        customStyles?.components?.primaryButton?.position ||
        "center",
    },
  };
};
